module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/import/shapes/import-shapes.component.scss
// module id = ./src/app/admin/import/shapes/import-shapes.component.scss
// module chunks = main